

import Previewer from 'vux/src/components/previewer/index.vue'

import wx from 'wx'
import Divider from 'vux/src/components/divider/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default{
props: {
eventHub: Object
},
directives: {
TransferDom
},
components: {
Divider,
XDialog,
XButton,
Group,
XSwitch,
Previewer,
wx
},
created(){
this.matchId = this.$route.query.matchId;
},
mounted(){

this.initTab();
},
data(){
return {
matchId: '',//352917
content: '动态数据',
indexContentHeight: 0,
assets: [],
imagelist: [],
teamUrl: '',
defaultImg: 'this.src="' + require('../assets/img/no_pic.png') + '"',
options: {
getThumbBoundsFn (index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]

let pageYScroll = window.pageYOffset || document.documentElement.scrollTop


let rect = thumbnail.getBoundingClientRect()

return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}


},
}
}
},
methods: {
initTab(){
this.$nextTick(() => {
this.indexContentHeight = document.body.clientHeight;
})

this.hagkHttp(this.hagkApi.getMatchAssetsByMatchId(this.matchId, 'dynamic'), {})
.then((res) => {
this.imagelist.splice(0, this.imagelist.length);
this.assets.splice(0, this.assets.length);
if (res && res.length > 0) {
for (var i = 0; i < res.length; i++) {
for (var j = 0; j < res[i].assetList.length; j++) {
var description = res[i].assetList[j].description
if(description && description.startsWith('http')) { // 球队数据
this.teamUrl = description;
} else {
var data = {};
data.url = this.hagkApi.getImgAssetById(res[i].assetList[j].assetId).url;
data.thumbnail_url = this.hagkApi.getImgAssetById(res[i].assetList[j].thumbnailId).url;
data.type = res[i].assetList[j].type;
data.description = res[i].assetList[j].description
this.assets.push(data)
}
}
}

for (var i = 0; i < this.assets.length; i++) {
var data = {};
data.src = this.assets[i].url;
data.actSrc = this.assets[i].url;
data.type = this.assets[i].type;
data.thumbnail_url = this.assets[i].thumbnail_url
data.description = this.assets[i].description
this.imagelist.push(data)
}
}
this.changeMomentHeight();
}, (error) => {

});
},
showImage (src) {
var urls = [];
for(var i=0;i<this.imagelist.length;i++){
urls.push(this.imagelist[i].src);
}
wx.previewImage({
current: src,
urls: urls
})
},
changeMomentHeight(){
if(this.eventHub){
this.eventHub.$emit("resetView");
}

},
jump: function () {
window.open(this.teamUrl, '_blank');
}
}
}



// WEBPACK FOOTER //
// ./src/views/matchDynamic.vue